import React, { Fragment, useState, useEffect, useContext } from 'react';
import LayoutDashboard from '../../Components/Layout/LayoutDashboard';
import { 
	Grid, 
	Box, 
	Paper,
	Container, 
	Tooltip, 
	Button, 
	TextField, 
	Typography, 
	IconButton,
	InputLabel,
	FormControl
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useForm } from "react-hook-form";
import SchedulesContext from "../../Reducers/Schedules/SchedulesContext";
import SelectCourse from '../SelectOptions/SelectCourse';
import SelectClassroom from '../SelectOptions/SelectClassroom';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import MethodGet from '../../Config/Services';
/**Importar Sweetalert2 * */
import Swal from 'sweetalert2';

/**importar spinner */
import Spinner from '../../Complements/Spinner';
import SelectSchools from '../SelectOptions/SelectSchools';

/** Importar Moment */
import Moment from 'moment';


const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
		paddingLeft: theme.spacing(10),
		//marginBottom: theme.spacing(10),
	},
	typography: {
		margin: theme.spacing(1),
    marginBottom:theme.spacing(2),
		//paddingLeft: theme.spacing(30),
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(9),
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
		marginBlockEnd: theme.spacing(1),
	},
	submit: {
		background: 'indigo',
		'&:hover': {
			background: '#5902CF',
		},
		color: 'white',
	},
	formControl: {
		//margin: theme.spacing(1),
		width: '100%',
	},
	input: {
		display: 'none',
	},
	containerImageProfile:{
		display:'flex',
		flexDirection:'row',
		flexWrap:'wrap',
		justifyContent:'space-around',

	},
	PaperFormAdd:{
	background:'white',
	color:'black',
	boxShadow: '2px 4px 4px #cacaca',
	},
}));

export default function EditClass(props) {
  const classes = useStyles();
    
    const [ dates_start , saveDatesStart ] = useState('');
    const [ dates_end , saveDatesEnd ] = useState('');
    const [selectedDateStart, handleDateChangeStart] = useState(new Date());
    const [selectedDateEnd, handleDateChangeEnd] = useState(new Date());
    
    const changeDate = (date) => {
      const DateFormat = Moment(date).format('YYYY-MM-DD');
      saveDatesStart(DateFormat);
      handleDateChangeStart(date);
  };
    
    const changeDateEnd = (date) => {
      const DateFormat = Moment(date).format('YYYY-MM-DD');
      saveDatesEnd(DateFormat);
      handleDateChangeEnd(date);
  };

		const [cargando, spinnerCargando] = useState(false);
    const [schedule, saveSchedule] = useState({});
    
    //Trabajar con el state de office
	  const [officeId, saveOffice] = useState({
		  id_branch_office: '',
	  });
    
    //Funciones para almacenar el id de school
	  const detectarCambiosSchool = (e) => {
		  saveOffice({
        id_branch_office: e.target.value,
      });
	  };

	const formScheduleContext = useContext(SchedulesContext);
  
  const { ErrorsAPI, success, UpdateClass } = formScheduleContext;

  const [SchoolStorageID, saveSchool] = useState('');

  useEffect(() => {
    if(officeId.id_branch_office != SchoolStorageID){
      saveSchool(officeId.id_branch_office);
      saveCourse('');
      saveClassroom('');
    }
	  }, [officeId]);

  const [course, saveCourse] = useState('');
  
    const detectarCambiosCourses = (e) => {
      saveCourse(e.target.value);
    };

  const [classroom, saveClassroom] = useState('');
  
    const detectarCambiosClassrooms = (value) => {
      saveClassroom(value.key);
    };

    const {start_time, end_time} = schedule;

  //obtenemos el producto de session storage
	let ClassStorageId = JSON.parse(sessionStorage.getItem("classSchedule"));

	//Funcion para validaciones
	const { register, handleSubmit, errors } = useForm();

  useEffect(() => {
		  let url = `/classInfo/${ClassStorageId}`;
	  
		  MethodGet(url)
			  .then((res) => {
				  saveSchedule(res.data.data);
				  saveSchool(res.data.data.branch_office_id)
				  saveClassroom(res.data.data.classroom_id)
          handleDateChangeStart(res.data.data.date_init)
          handleDateChangeEnd(res.data.data.date_end)
          saveDatesStart(res.data.data.start_date)
          saveDatesEnd(res.data.data.end_date)
				  //saveOffice({ id_branch_office: res.data.data.branch_office_id })
				  spinnerCargando(true);
			  })
			  .catch((error) => {
                spinnerCargando(true);
				  console.log(error);
			  });
	  }, []);

	const onSubmit = (data, e) => {
		e.preventDefault();
    data.classroom = classroom;
    data.start_date = dates_start;
    data.end_date = dates_end;
    data.id = ClassStorageId;

    if(classroom != '')
    {
        UpdateClass(data);
    } else {
      Swal.fire({
        title: 'Error',
        text: "Todos los campos son Obligatorios",
        icon: 'error'
      });
    }

	};

	useEffect(() => {
		//si success retorna verdadero la pagina redireccionara al index de Programaciones
		if (success) {
		  //console.log("Retorna");
		  props.history.push(`/ProgramacionDiplomado`); 
		}
	  }, [success]);
	//  spinner de carga
	if (!cargando) return <Spinner />;

  return (
    <LayoutDashboard>
      <div className={classes.root}>
      <Container className={classes.container}>
				<Paper className={classes.PaperFormAdd}>
        <form onSubmit={handleSubmit(onSubmit)} className={classes.form} noValidate>
          <Box className={classes.typography}>
            <Typography component="h1" variant="h4" align="center" className={classes.typography}>
              Edición de Programación De Cursos
            </Typography>
          </Box>
          <Grid container spacing={2}>
                <Grid item xs={12} sm={6} style={{marginTop:'15px'}}>
				    <FormControl className={classes.formControl}>
					    <SelectClassroom
                classroom={classroom}
						    detectarCambiosClassrooms={detectarCambiosClassrooms}
			    		  SchoolStorageID={SchoolStorageID}
    				  /> 
					</FormControl>
			    </Grid>

                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid item xs={12} sm={6}>
                      <KeyboardDatePicker
                          autoOk
                          fullWidth
                          inputVariant="outlined"
                          variant="inline"
                          format="dd/MM/yyyy"
                          margin="normal"
                          disablePast
                          label="Fecha Inicio"
                          value={selectedDateStart}
                          onChange={changeDate}
                          InputAdornmentProps={{ position: "start" }}
                      />
                  </Grid>
                </MuiPickersUtilsProvider>

                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid item xs={12} sm={6}>
                      <KeyboardDatePicker
                          autoOk
                          fullWidth
                          inputVariant="outlined"
                          variant="inline"
                          format="dd/MM/yyyy"
                          margin="normal"
                          label="Fecha Final"
                          disablePast
                          value={selectedDateEnd}
                          onChange={changeDateEnd}
                          InputAdornmentProps={{ position: "start" }}
                      />
                  </Grid>
                </MuiPickersUtilsProvider>

                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="start_time"
                    label="Hora Inicial"
                    name="start_time"
                    autoComplete="name"
                    type="time"
                    defaultValue={start_time}
                    autoFocus
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      step: 300, // 5 min
                    }}
                    error={!!errors.start_time}
                    inputRef={register({
                      required:{
                        value:true,
                        message: 'La Hora de Inicio es requerido',
                      },
                    })}
                  />
                  <p>{errors?.start_time?.message}</p>
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="end_time"
                    label="Hora De Término"
                    name="end_time"
                    autoComplete="name"
                    type="time"
                    defaultValue={end_time}
                    autoFocus
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      step: 300, // 5 min
                    }}
                    error={!!errors.end_time}
                    inputRef={register({
                      required:{
                        value:true,
                        message: 'La Hora De Término es requerida',
                      },
                    })}
                  />
                  <p>{errors?.end_time?.message}</p>
                </Grid>
                </Grid>
          <Grid container spacing={3} justify="center">
						<Grid item spacing={3} xs={12} sm={12} md={6}>
							<Button
								type="submit"
								fullWidth
								variant="outlined"
								className={classes.submit}
							>
								GUARDAR
							</Button>
						</Grid>
					</Grid>
        </form>
        </Paper>
				</Container>
      </div>
    </LayoutDashboard>
  );
}